import Typography from "components/common/Typography";
import { useTranslate } from "hooks/useTranslate";
import { useAppSelector } from "redux/hooks";
import colors from "styles/Colors";
import { tokens } from "styles/Tokens";
import { helperTexts } from "utils/CommonConstants";
import { convertBooleanToStatus } from "utils/CommonFunctions";
import { getInitialState, labelFromKey } from "../AdminConsole";
import "./MyPermissions.scss";

const MyPermissions = () => {
  const userPermissionInfo = useAppSelector((state) => state.app.loggedInUserDetails);
  const data = userPermissionInfo && getInitialState(userPermissionInfo);
  const convertableKeys = ["adminConsoleAccess"];
  const translate = useTranslate();
  return (
    <div className="my-permission-component">
      <div className="my-permission-heading">
        <Typography variant={"body2"} showBold color={tokens.Text.General.PrimaryBody}>
          {translate("adminConsole.myPermission.heading")}
        </Typography>
      </div>
      <div className="my-permission-list">
        {data &&
          Object.entries(data)?.map((el: any) => {
            let values = ["n", "N"];
            let val = convertableKeys.includes(el[0]) ? convertBooleanToStatus(el[1]) : el[1];
            const label = labelFromKey[el[0]];
            return (
              <div key={el[0]} className={values.includes(el[1]) ? " d-none" : ""}>
                <Typography variant={"label"} color={colors.Neutral.Neutral400} component={"div"}>
                  {label}
                </Typography>

                <Typography variant={"body2"} color={tokens.Text.General.PrimaryHeadline} component={"div"}>
                  {val}
                </Typography>

                {el[0] === "permission" && (
                  <Typography
                    variant={"label"}
                    color={tokens.Text.General.Secondary}
                    component={"div"}
                    className="permission-helper-text"
                  >
                    {helperTexts[label]}
                  </Typography>
                )}
              </div>
            );
          })}
      </div>
      <div className="my-permission-text-wrapper">
        {" "}
        <Typography variant={"body2"} color={tokens.Text.General.PrimaryBody}>
          {translate("adminConsole.myPermission.footer")}

          <a target={"_blank"} href="mailto:boost.support@hilton.com" rel="noreferrer">
            {" "}
            boost.support@hilton.com
          </a>
        </Typography>
      </div>
    </div>
  );
};

export default MyPermissions;
